"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWebAsmModulePromiseWithAugmentedTypes = exports.addTsMemoryToModule = void 0;
// The good folks who wrote the below typings didn't write them to be importable as a module.
/// <reference types="emscripten" />
const async_friendly_finally_1 = require("./async-friendly-finally");
/**
 * This function wrapa WebAssembly module generated by Emscriptem
 * with functions to allocate raw pointers in that module's memory space
 * and pass them to functions that accept a raw pointer via a field defined
 * as type size_t.
 *
 * To ensure memory used to pass or retrieve data from a WebAssembly module
 * is freed, it's best to use usingByteArray when receiving data from a module
 * and usingCopyOfArray when passing data to it.  Those methods allocate memory
 * for the lifetime of a callback (handling async callbacks by waiting for
 * promises to resolve or reject) before freeing memory.
 */
function addTsMemoryToModule(module) {
    const allocateU8 = (size) => {
        const ptr = module._malloc(size);
        return module.HEAPU8.subarray(ptr, ptr + size);
    };
    const freeU8 = (array) => {
        module._free(array.byteOffset);
    };
    const usingByteArray = (arrayLengthInbytes, callback) => {
        var array = allocateU8(arrayLengthInbytes);
        return (0, async_friendly_finally_1.asyncFriendlyFinally)(() => callback(array), () => freeU8(array));
    };
    const usingCopyOfArray = (fromArray, callback) => usingByteArray(fromArray.length * fromArray.BYTES_PER_ELEMENT, (newArray) => {
        newArray.set(fromArray);
        return callback(newArray);
    });
    return Object.assign(module, { tsMemory: { allocateU8, freeU8, usingByteArray, usingCopyOfArray } });
}
exports.addTsMemoryToModule = addTsMemoryToModule;
;
/**
 * Take the default export of an Emscriptem module and turn it into a promise for a copy
 * of the module, augmented with our TypeScript methods for using memory in the webasm module.
 *
 * @param functionReturningASadAndBuggyExcuseForAModulePromise That which emscriptem exports in modules
 * has been given a then function to look like a promise, but treating it like a promise yields an
 * infinite loop.  Don't worry, just pass that sh*t here and we'll fix it for you.
 * (For more info, see https://github.com/emscripten-core/emscripten/issues/5820 and how we've
 * implemented this.)
 */
const getWebAsmModulePromiseWithAugmentedTypes = (aSadAndBuggyExcuseForAModulePromise) => new Promise((resolveModule, reject) => {
    try {
        aSadAndBuggyExcuseForAModulePromise.then((module) => {
            // The good folks at emscripten didn't understand promises when they decided to make their
            // modules look kindof like promises to return modules and augmenting them with a .then()
            // method.  Alas, rather than the then() returning the module, the then() was just another
            // field on the object, and so if you awaited it you'd be stuck in an infinite loop of
            // calls to then.  This hack in the next line, removing the then() method after it is called,
            // fixes it until the fix from them is released and likely to be in the toolchain of
            // anyone who might build this.
            //
            // https://github.com/emscripten-core/emscripten/issues/5820
            delete module['then'];
            resolveModule(addTsMemoryToModule(module));
        });
    }
    catch (e) {
        reject(e);
    }
});
exports.getWebAsmModulePromiseWithAugmentedTypes = getWebAsmModulePromiseWithAugmentedTypes;
